var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "file-download" }, [
    typeof _vm.seqNo == "number" && _vm.seqNo > 0
      ? _c("div", { staticClass: "fileseq" }, [_vm._v(_vm._s(_vm.seqNo))])
      : _vm._e(),
    _vm._v(" "),
    _c("label", { staticClass: "filename", attrs: { name: "fileName" } }, [
      _vm._v(_vm._s(_vm.loadFileName || "未命名文件"))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "stateinfo ml5 mr5 fr" }, [
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loadState == 0,
            expression: "loadState == 0"
          }
        ],
        staticClass: "icon iconfont icon-xiajia",
        class: { clickable: _vm.clickable },
        on: { click: _vm.doClickDownload }
      }),
      _vm._v(" "),
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loadState == 1,
            expression: "loadState == 1"
          },
          {
            name: "resc-url",
            rawName: "v-resc-url",
            value: "/image/loading.gif",
            expression: "'/image/loading.gif'"
          }
        ],
        staticClass: "icon-loading",
        staticStyle: { width: "16px", height: "16px" }
      }),
      _vm._v(" "),
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loadState == 2,
            expression: "loadState == 2"
          }
        ],
        staticClass: "icon iconfont icon-success"
      }),
      _vm._v(" "),
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loadState == -1,
            expression: "loadState == -1"
          }
        ],
        staticClass: "icon iconfont icon-error"
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "loadinfo fr", attrs: { name: "loadInfo" } }, [
      _c(
        "label",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loadState == 1,
              expression: "loadState==1"
            }
          ]
        },
        [_vm._v(_vm._s(_vm.loadedBytes || "--") + "/")]
      ),
      _c("label", [_vm._v(_vm._s(_vm.totalBytes || "--"))])
    ]),
    _vm._v(" "),
    _vm.seqNo <= 0 && _vm.xlsExport == true
      ? _c(
          "div",
          { staticStyle: { position: "absolute", "margin-top": "10px" } },
          [
            _c(
              "el-checkbox",
              {
                staticStyle: { color: "navy" },
                model: {
                  value: _vm.valueAsNormalFormats,
                  callback: function($$v) {
                    _vm.valueAsNormalFormats = $$v
                  },
                  expression: "valueAsNormalFormats"
                }
              },
              [_vm._v("按常规格式输出数据")]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-287023e3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-287023e3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/ctrl/FileDownload.vue
// module id = 1627
// module chunks = 1